module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/mic-v2-da8489f7b368779b4fd04c1bc58a6766.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/mic-v2.svg
// module id = 2IF+
// module chunks = 1 3 10 12 18